import { render, staticRenderFns } from "./ForgotPass.vue?vue&type=template&id=08900ca0&scoped=true&"
import script from "./ForgotPass.vue?vue&type=script&lang=js&"
export * from "./ForgotPass.vue?vue&type=script&lang=js&"
import style1 from "./ForgotPass.vue?vue&type=style&index=1&id=08900ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08900ca0",
  null
  
)

export default component.exports